import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { dashboardService } from '../../services/dashboardService';

export const useGetLenderDashboardStats = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.dashboard.lender_stats],
    queryFn: () =>
      dashboardService.lenderStats().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
